export default __webpack_public_path__ + "static/media/1492.a5c957c4.png";